import { BanknotesIcon, CubeIcon } from "@heroicons/react/24/outline";
import { t } from "@lingui/core/macro";
import { Link, createFileRoute } from "@tanstack/react-router";

import { HelpBlock, OptionCard, Screen, useFlowNavigate } from "../-components/Withdrawal/WithdrawalFlow";

const WithdrawalLandingScreen = () => {
  const navigate = useFlowNavigate();

  return (
    <Screen subtitle={t`Select a cash or product withdrawal`} step={{ index: 1, total: 4 }}>
      <div className="flex flex-col gap-4 @md:flex-row">
        <OptionCard
          icon={<BanknotesIcon className="h-5 w-5" />}
          title={t`Cash`}
          description={t`Sell your metal and receive funds by wire or ACH.`}
          onClick={() => navigate("cash")}
        />
        <OptionCard
          icon={<CubeIcon className="h-5 w-5" />}
          title={t`Products`}
          description={t`Receive physical metal as coins or bars.`}
          onClick={() => navigate("products")}
        />
      </div>

      <p className="text-sm text-muted-foreground">
        {t`Available metal and next steps will be shown after you make a selection.`}
      </p>

      <p className="text-sm text-muted-foreground">
        Track your withdrawals in{" "}
        <Link className="text-primary hover:underline" to="/trade/pending">
          {t`Recent Transactions`}
        </Link>
        .
      </p>

      <HelpBlock />
    </Screen>
  );
};

export const Route = createFileRoute("/_authenticated/trade/withdraw/")({
  component: WithdrawalLandingScreen,
});
